import React from "react";
import styled from "styled-components";
import { colors } from "../../../../../utils/theme";

const Container = styled.div`
  width: 100%;
  .form {
    border-bottom: 1px solid #00000029;
    padding: 1rem 0;
    width: 95%;
    margin: 0 auto;
  }
`;

const ContainerFormInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;
const FormInputInfo = styled.div`
  width: 25%;
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (max-width: 1440px) {
    width: 30%;
  }
  @media (max-width: 768px) {
    width: 45%;
  }
  @media (max-width: 500px) {
    width: 90%;
  }

  label {
    width: 100%;
    color: ${colors.third};
    font-weight: 600;
    @media (max-width: 1024px) {
      text-align: start;
    }
  }

  input {
    width: 80%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  .button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    @media (max-width: 1440px) {
      width: 30%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

const handleInputChange = (newValue) => {
    console.log("");
  };

const OrderFormPatient = ({patient}) => {
  return (
    <div>
      <ContainerFormInfo>
        <FormInputInfo>
          <label>ÁREA AFECTADA</label>
          <input
            type="text"
            value={patient.areaAfectada}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>NO. DE ORDEN</label>
          <input
            type="text"
            value={patient.numeroDeOrden}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
        <FormInputInfo>
          <label>AUTORIZACIÓN</label>
          <input
            type="text"
            value={patient.autorizacion}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>SESIONES AUTORIZADAS</label>
          <input
            type="text"
            value={patient.sesionesAutorizadas}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
        <FormInputInfo>
          <label>SESIONES REALIZADAS</label>
          <input
            type="text"
            value={patient.sesionesRealizadas}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>ENTIDAD</label>
          <input
            type="text"
            value={patient.entidad}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>MÉDICO REMITENTE</label>
          <input
            type="text"
            value={"ANTONIO JOSE BERMUDEZ TORRENEGRA"}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>

        <FormInputInfo>
          <label>FECHA</label>
          <input
            type="text"
            value={patient.fechaInicioTratamiento}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormInputInfo>
      </ContainerFormInfo>
    </div>
  );
};

export default OrderFormPatient;
